import type {Game, GameApi, GamesApiResponse} from "./games.types";

const adaptGame = (game: GameApi): Game => ({
  id: String(game.id),
  name: game.name,
  provider: game.provider ?? "",
  category: game.category ?? game.game_class ?? "",
  imageUrl: game.image ?? game.thumbnail ?? game.logo ?? "",
});

export const adaptGames = (response: GamesApiResponse): Game[] => response.data.data.map(adaptGame);
